'use client';

import { c as _c } from "react/compiler-runtime";
import type { RefObject } from 'react';
import * as SubframeCore from '@subframe/core';
import { FeatherChevronDown, FeatherDownload } from '@subframe/core';
import type { FormatoDownload } from '../types/baixarProcesso.types';
import { FORMATOS_DOWNLOAD, ICONE_POR_FORMATO } from '../utils/formatosDownload';
interface BaixarProcessoMenuProps {
  aberto: boolean;
  /** O painel devolve o foco a este botão ao fechar. */
  gatilhoRef: RefObject<HTMLButtonElement | null>;
  onAbertoChange: (aberto: boolean) => void;
  onEscolherFormato: (formato: FormatoDownload) => void;
}
export function BaixarProcessoMenu(t0) {
  const $ = _c(15);
  const {
    aberto,
    gatilhoRef,
    onAbertoChange,
    onEscolherFormato
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <FeatherDownload className="h-4 w-4 text-neutral-600" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <FeatherChevronDown className="h-[15px] w-[15px] text-neutral-400" />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== gatilhoRef) {
    t3 = <SubframeCore.DropdownMenu.Trigger asChild={true}><button ref={gatilhoRef} className="text-default-font bg-default-background flex h-9 flex-none items-center gap-2 rounded-[8px] border border-solid border-neutral-200 pr-[10px] pl-3 text-sm font-medium whitespace-nowrap hover:bg-neutral-50 data-[state=open]:bg-neutral-50" type="button">{t1}Baixar processo completo{t2}</button></SubframeCore.DropdownMenu.Trigger>;
    $[2] = gatilhoRef;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <SubframeCore.DropdownMenu.Label className="px-3 pt-[10px] pb-2 text-[10.5px] font-semibold tracking-[0.05em] text-neutral-500 uppercase">Formato do download</SubframeCore.DropdownMenu.Label>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== onEscolherFormato) {
    t5 = FORMATOS_DOWNLOAD.map(opcao => <SubframeCore.DropdownMenu.Item asChild={true} key={opcao.chave} onSelect={() => onEscolherFormato(opcao.chave)}><button className="focus-visible:ring-brand-600/20 flex w-full cursor-pointer items-start gap-[10px] rounded-[8px] px-3 py-[10px] text-left hover:bg-neutral-50 focus:outline-none focus-visible:ring-2 data-[highlighted]:bg-neutral-100" type="button"><span className="text-brand-600 mt-[2px] flex-none">{ICONE_POR_FORMATO[opcao.chave]}</span><span className="flex min-w-0 flex-1 flex-col gap-[2px]"><span className="flex flex-wrap items-center gap-2"><span className="text-default-font text-[13.5px] font-medium">{opcao.titulo}</span>{opcao.selo ? <span className="border-brand-100 bg-brand-50 text-brand-600 inline-flex flex-none items-center rounded-md border border-solid px-1.5 py-0.5 text-[10px] leading-[1.3] font-semibold whitespace-nowrap">{opcao.selo}</span> : null}</span><span className="text-[12px] leading-[1.5] text-neutral-500">{opcao.descricao}</span></span>{opcao.resultado ? <span className="flex-none pt-[2px] text-[11.5px] whitespace-nowrap text-neutral-400 tabular-nums">{opcao.resultado}</span> : null}</button></SubframeCore.DropdownMenu.Item>);
    $[5] = onEscolherFormato;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <p className="mx-2 mt-1.5 mb-1 border-t border-solid border-neutral-100 pt-[9px] text-[11.5px] leading-[1.5] text-neutral-500">O PDF completo e o ZIP saem direto. “Algumas seções” abre o painel de seleção.</p>;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t5) {
    t7 = <SubframeCore.DropdownMenu.Portal><SubframeCore.DropdownMenu.Content align="end" sideOffset={6}><div className="animate-fade-in bg-default-background w-[404px] max-w-[calc(100vw-2rem)] rounded-[16px] border border-solid border-neutral-200 p-[6px] shadow-lg">{t4}{t5}{t6}</div></SubframeCore.DropdownMenu.Content></SubframeCore.DropdownMenu.Portal>;
    $[8] = t5;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== aberto || $[11] !== onAbertoChange || $[12] !== t3 || $[13] !== t7) {
    t8 = <SubframeCore.DropdownMenu.Root onOpenChange={onAbertoChange} open={aberto}>{t3}{t7}</SubframeCore.DropdownMenu.Root>;
    $[10] = aberto;
    $[11] = onAbertoChange;
    $[12] = t3;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
}